/**
 * The value is the intended queryParam to be used in the URL, "urlKey" in nuqs setup
 * Conflicting values will produce a linting error.
 **/
export const QUERY_PARAM_REGISTRY = {
  // map
  zoom: 'z',
  center: 'center',

  // visual analysis
  dataCollectionId: 'dataCollection',
  configuration: 'configuration',
  layer: 'layer',
  bottomPanel: 'bottom-panel',
  statsSource: 'stats-source',
  statsCC: 'stats-cc',
  dateTimeFrom: 'from',
  dateTimeTo: 'to',
  statsDateFrom: 'stats-from',
  statsDateTo: 'stats-to',
  // settings
  mosaickingOrder: 'mosaicking',
  upsampling: 'upsampling',
  downsampling: 'downsampling',
  // effects
  gain: 'gain',
  gamma: 'gamma',
  redRange: 'rr',
  greenRange: 'rg',
  blueRange: 'rb',
  // super-res
  superRes: 'super-res',
  confidenceThreshold: 'confidence-threshold',
  superResOpacity: 'opacity',

  // data collections
  dataCollectionTab: 'tab',

  // feature collections (collection ref + feature ref)
  ref: 'ref',

  //mosaics
  series: 'series',
  mosaic: 'mosaic',
  process: 'proc',
  color: 'color',

  // Orders/Subs/Destinations
  sortBy: 'sort_by',

  // impersonation
  impersonatedUserId: 'impersonating_user',
  impersonatedProjectId: 'impersonating_project',
};
